/**
 * Route paths – tek yerden yönetim, link ve redirect'lerde kullan.
 */
export const ROUTES = {
  HOME: '/',
  ABOUT: '/#about',
  CONTACT: '/contact',
  NEWS: '/news',
  PRODUCTS: '#products',
  PRIVACY: '/privacy',
  TERMS: '/terms',
  COMPLIANCE: '/compliance',
  ACCESSIBILITY: '/accessibility',
  SEARCH: '/search',
};

export const ROUTE_LIST = [
  { path: ROUTES.HOME, label: 'HOME' },
  { path: ROUTES.ABOUT, label: 'ABOUT' },
  { path: ROUTES.PRODUCTS, label: 'PRODUCTS' },
  { path: ROUTES.CONTACT, label: 'CONTACT' },
];
